import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { MovesSummaryComponent } from './summary.component';
import { UButtonGroupComponent } from '@updater/angular-common';
import { AddressModule } from '@updater-components/address';
import config from './summary.config.js';
import services from '../../../common/services';
import { BackToDashboardButtonComponent } from '../../../common/directives/back-to-dashboard-button';

export const MovesSummaryModule = angular
  .module('app.account.moves.summary', [
    AddressModule.name,
    services.name,
    uiRouter,
    UButtonGroupComponent.name,
    BackToDashboardButtonComponent.name,
  ])
  .config(config)
  .component('updMovesSummary', MovesSummaryComponent);
